const forceLinksInNewTab = (html) => {
  if (!html) return html;
  return html.replace(
    /<a\b(?![^>]*\btarget=)/gi,
    '<a target="_blank" rel="noopener noreferrer"'
  );
};

export default forceLinksInNewTab;
